export const googleMapsUrl = `https://maps.google.com/maps?daddr=Leidsegracht+6H,+1016+CK,+Amsterdam,+Netherlands`
